
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export type Severity = "info" | "success" | "warning" | "error";
export interface UpdateItem {
  id: string;
  title: string;
  content: string;         // HTML destekli kısa açıklama
  createdAt: any;       // ISO
  severity: Severity;
  read: boolean;
  tags?: string[];
  products?: Array<{text: string; value: number}>;     // Ürün adları ve ID'leri
}

@Component
export default class GuncellemelerDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Array,   default: () => [] }) items!: UpdateItem[];
  @Prop({ type: Boolean, default: false }) loading!: boolean;

  internalValue = this.value;
  q = "";

  @Watch("value") onV(n: boolean) { this.internalValue = n; }
  @Watch("internalValue") onIV(n: boolean) { this.$emit("input", n); }

  get filtered(): UpdateItem[] {
    const text = this.q.trim().toLowerCase();
    let list = this.items.slice();
    if (text) {
      list = list.filter(
          x =>
              x.title.toLowerCase().includes(text) ||
              x.content.toLowerCase().includes(text) ||
              (x.tags || []).some(t => t.toLowerCase().includes(text))
      );
    }
    // son güncelleme en üstte
    return list.sort((a, b) => +new Date(b.createdAt) - +new Date(a.createdAt));
  }

  formatDate(iso: string) {
    try {
      const d = new Date(iso);
      return d.toLocaleString();
    } catch {
      return iso;
    }
  }

  iconOf(s: Severity) {
    switch (s) {
      case "success": return "mdi-check-decagram-outline";
      case "warning": return "mdi-alert-circle-outline";
      case "error":   return "mdi-alert-octagon-outline";
      default:        return "mdi-information-outline";
    }
  }
  colorOf(s: Severity) {
    switch (s) {
      case "success": return "green";
      case "warning": return "orange";
      case "error":   return "red";
      default:        return "primary";
    }
  }

  productColorOf(productId: number): string {
    switch (productId) {
      case 1: return "#761616";
      case 2: return "#0f547b";
      case 3: return "#4c7128";
      case 4: return "red";
      default: return "primary";
    }
  }

  onMarkRead(it: UpdateItem) {
    if (it.read) return;
    this.$emit("mark-read", it.id);
  }
}
